import { ApplicationEvaluationRequest, ApplicationEvaluationResponse } from '@blk/aw-bff-typescript-models';
import { AxiosResponse, CancelToken } from 'axios';
import { EnumPrefixConfig, prefixEnumsForAGraph } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { awBffApi } from './Base';

// Request enum prefixes for AGraph
const AGRAPH_REQUEST_ENUM_PREFIXES: EnumPrefixConfig[] = [
  { fieldNames: ['operator'], prefix: 'FILTER_OPERATOR_', recursiveFieldPatterns: ['filters', 'unionFilters'] },
  { fieldNames: ['valueType'], prefix: 'FILTER_VALUE_TYPE_', recursiveFieldPatterns: ['filters', 'unionFilters'] },
];

export interface EvaluateCountParams {
  configurationDirectory?: string;
  pkg: string;
  viewAs?: string;
}

export function postEvaluateCount(
  evaluateCountRequest: ApplicationEvaluationRequest,
  params: EvaluateCountParams,
  cancelToken?: CancelToken
): Promise<AxiosResponse<ApplicationEvaluationResponse>> {
  const path = '/application-mode/evaluate-count';
  const payload = isAGraphEnabled()
    ? prefixEnumsForAGraph(evaluateCountRequest, AGRAPH_REQUEST_ENUM_PREFIXES)
    : evaluateCountRequest;

  return awBffApi.post<ApplicationEvaluationResponse>(path, payload, { cancelToken, params });
}
